import tutorial1Sound from 'assets/sounds/adult/se/sprakforstaelsaSounds/SF-1.mp3';
import tutorial1isCorrectSound from 'assets/sounds/adult/se/sprakforstaelsaSounds/SF-1-if-correct.mp3';
import tutorial1isWrongSound from 'assets/sounds/adult/se/sprakforstaelsaSounds/SF-1-if-wrong.mp3';

import tutorial2Sound from 'assets/sounds/adult/se/sprakforstaelsaSounds/SF-2.mp3';
import tutorial2isCorrectSound from 'assets/sounds/adult/se/sprakforstaelsaSounds/SF-2-if-correct.mp3';
import tutorial2isWrongSound from 'assets/sounds/adult/se/sprakforstaelsaSounds/SF-2-if-wrong.mp3';

import tutorial3Sound from 'assets/sounds/adult/se/sprakforstaelsaSounds/SF-1.mp3';
import tutorial3isCorrectSound from 'assets/sounds/adult/se/sprakforstaelsaSounds/SF-1-if-correct.mp3';
import tutorial3isWrongSound from 'assets/sounds/adult/se/sprakforstaelsaSounds/SF-1-if-wrong.mp3';
import tutorial3isWrongOrder from 'assets/sounds/adult/se/sprakforstaelsaSounds/SF-1-if-wrong.mp3';

import starterTesten from 'assets/sounds/adult/se/sprakforstaelsaSounds/after-Introduksjon-sprakforstael.mp3';

import trial1A from '../assets/TestImages/Ø1_2.png';
import trial1B from '../assets/TestImages/Ø1_1.png';
import trial1C from '../assets/TestImages/Ø1_3.png';
import trial1D from '../assets/TestImages/Ø1_4.png';

import trial2A from '../assets/TestImages/Ø2_1.png';
import trial2B from '../assets/TestImages/Ø2_2.png';
import trial2C from '../assets/TestImages/Ø2_3.png';
import trial2D from '../assets/TestImages/Ø2_4.png';

import trial3A from '../assets/TestImages/Ø3.png';
import trial3B from '../assets/TestImages/Ø3(2).png';
import trial3C from '../assets/TestImages/Ø3(5).png';
import trial3D from '../assets/TestImages/Ø3(4).png';
import trial3E from '../assets/TestImages/Ø3(1).png';
import trial3F from '../assets/TestImages/Ø3(3).png';

export const starterTestenSound = starterTesten;

export const assignment1 = [
	{
		id: 1,
		mainSound: tutorial1Sound,
		text: 'Hitta bilden som visar kvinnan som inte skriver på datorn, utan som läser en bok.',
		choices: [
			{
				word: 'a',
				remarks: false,
				img: trial1A,
				sound: tutorial1isWrongSound,
				comment:
					'Dette ble dessverre ikke riktig. Se nøye på bildene. Kan du finne bildet som viser at dama leser en bok? Husk, hun skal i̲k̲k̲e̲ skrive på datamaskinen',
			},
			{
				word: 'b',
				remarks: true,
				img: trial1B,
				sound: tutorial1isCorrectSound,
				comment: 'Du fant helt riktig bilde - så bra.',
			},
			{
				word: 'c',
				remarks: false,
				img: trial1C,
				sound: tutorial1isWrongSound,
				comment:
					'Dette ble dessverre ikke riktig. Se nøye på bildene. Kan du finne bildet som viser at dama leser en bok? Husk, hun skal i̲k̲k̲e̲ skrive på datamaskinen.',
			},
			{
				word: 'd',
				remarks: false,
				img: trial1D,
				sound: tutorial1isWrongSound,
				comment:
					'Dette ble dessverre ikke riktig. Se nøye på bildene. Kan du finne bildet som viser at dama leser en bok? Husk, hun skal i̲k̲k̲e̲ skrive på datamaskinen.',
			},
		],
	},
];

export const assignment2 = [
	{
		id: 2,
		mainSound: tutorial2Sound,
		text: 'Velg gutten som smiler fordi han har fått en presang.',
		choices: [
			{
				word: 'a',
				remarks: true,
				img: trial2A,
				sound: tutorial2isCorrectSound,
				comment: 'Du fant helt riktig bilde - så bra.',
			},
			{
				word: 'b',
				remarks: false,
				img: trial2B,
				sound: tutorial2isWrongSound,
				comment:
					'Dette ble dessverre ikke riktig. Se nøye på bildene. Kan du finne bildet som viser at gutten smiler o̲g̲ at han har fått en presang?',
			},
			{
				word: 'c',
				remarks: false,
				img: trial2C,
				sound: tutorial2isWrongSound,
				comment:
					'Dette ble dessverre ikke riktig. Se nøye på bildene. Kan du finne bildet som viser at gutten smiler o̲g̲ at han har fått en presang?',
			},
			{
				word: 'd',
				remarks: false,
				img: trial2D,
				sound: tutorial2isWrongSound,
				comment:
					'Dette ble dessverre ikke riktig. Se nøye på bildene. Kan du finne bildet som viser at gutten smiler o̲g̲ at han har fått en presang?',
			},
		],
	},
];

export const assignment3 = [
	{
		id: 3,
		mainSound: tutorial3Sound,
		correctSound: tutorial3isCorrectSound,
		wrongSound: tutorial3isWrongSound,
		wrongOrderSound: tutorial3isWrongOrder,
		text: 'Nå skal vi øve på å trykke på objekter i riktig rekkefølge. Du skal trykke på fruktene i den rekkefølgen jeg sier dem. "Trykk nå på fruktene i den rekkefølgen jeg sier: eple, banan, ananas.',
		correctComment:
			'Så flott - du valgte riktige bilder og i riktig rekkefølge.',
		wrongOrderComment:
			'Du valgte riktige bilder, men i feil rekkefølge. Husk å trykke på bildene i samme rekkefølge som jeg sier dem. Prøv en gang. Trykk på bildene som viser et eple, en banan og en ananas.',
		wrongComment:
			'Dette ble dessverre ikke riktig. Se nøye på bildene. Kan du nå trykke på bildene som viser et eple, en banan og en ananas? Husk å trykke på bildene i den samme rekkefølgen som jeg sier dem.',
		choices: [
			{
				word: 'a',
				img: trial3A,
			},
			{
				word: 'b',
				img: trial3B,
			},
			{
				word: 'c',
				img: trial3C,
			},
			{
				word: 'd',
				img: trial3D,
			},
			{
				word: 'e',
				img: trial3E,
			},
			{
				word: 'f',
				img: trial3F,
			},
		],
		correctOrder: ['c', 'a', 'd'],
	},
];
